import {
  SET_NO_DATES_AVAILABLE_FOR_REG_SCHEDULER,
  UPDATE_TOTAL_FOR_REG_SCHEDULER,
  UPDATE_SQUAD_QTY_FOR_REG_SCHEDULER,
  SET_SELECTED_DATE,
  DISPLAY_AVAILABLE_DATES,
  DISPLAY_SQUADS,
  DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS,
  UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER,
  UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER,
  UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER,
  UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER,
  UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER,
  SET_CALENDAR_SELECTED_DATE,
  DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED
} from './constants';

export const displayGuideIfBundled = squadId => ({
  type: DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED,
  payload: squadId
});

export const setNoDatesAvailable = value => ({
  type: SET_NO_DATES_AVAILABLE_FOR_REG_SCHEDULER,
  payload: value
});

export const setSelectedDate = date => ({
  type: SET_CALENDAR_SELECTED_DATE,
  payload: date
});

export const updateTotal = cart => ({
  type: UPDATE_TOTAL_FOR_REG_SCHEDULER,
  payload: cart
});

export const updateSquadQuantity = data => ({
  type: UPDATE_SQUAD_QTY_FOR_REG_SCHEDULER,
  payload: data
});

export const setSeletedDate = selectedDate => ({
  type: SET_SELECTED_DATE,
  payload: selectedDate
});

export const displayAvailableDates = data => ({
  type: DISPLAY_AVAILABLE_DATES,
  payload: data
});

export const displaySquads = data => ({
  type: DISPLAY_SQUADS,
  payload: data
});

export const displayVirtualEvents = data => ({
  type: DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS,
  payload: data
});

export const updateBowlerOwnedVirtualEventQuantity = (virtualEventId, quantity) => ({
  type: UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER,
  payload: {virtualEventId, quantity}
});

export const updateTeamOwnedVirtualEventQuantity = (eventId, virtualEventId, quantity) => ({
  type: UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER,
  payload: {eventId, virtualEventId, quantity}
});

export const updateSquadCountInCart = (squadId, quantity) => ({
  type: UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER,
  payload: {squadId, quantity}
});

export const updateBowlerOwnedVirtualEventCountInCart = (virtualEventId, count) => ({
  type: UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER,
  payload: {virtualEventId, count}
});

export const updateTeamOwnedVirtualEventCountInCart = (eventId, virtualEventId, count) => ({
  type: UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER,
  payload: {eventId, virtualEventId, count}
});



// WEBPACK FOOTER //
// ./src/features/registration/scheduler/actionTypes.js